import {throwError as observableThrowError, of as observableOf, Observable} from 'rxjs';
import {SwitchBoard} from './SwitchBoard';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Session} from './Session';
import {HttpErrorResponse} from '@angular/common/http';
import {map, catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "./TaxplanIQServices";
import {SOURCE_TYPE} from "../constants/Tpiq.constants";

declare let moment: any;
declare let _: any;

export function getChannelPostsUrl(org, userId, channelType, companyId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/posts`;
}

export function getChannelPostUrl(org, userId, channelType, channelId, postID) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/channels/${channelType}/${channelId}/posts/${postID}`;
}

export function getDeleteDocumentUrl(org, userId, channelType, companyId) {
  return `/TaxPlanningServices/user/${userId}/documents`;
}

export function getOrgCommentUrl(org, userId, postID) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/posts/${postID}/comments`;
}

export function getDocumentDownloadUrl(userId, companyId, documentId) {
  return `/TaxPlanningServices/user/${userId}/companies/${companyId}/documents/${documentId}`;
}

export function getCommentUrl(org, userId, postID, commentID) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/posts/${postID}/comments/${commentID}`;
}

export function getCompanyLikeUrl(userId, channelId, channelType, orgId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/channels/${channelType}/${channelId}/likes`;
}

export function getCompanyUnLikeUrl(orgId, userId, channelType, channelId, likeId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/channels/${channelType}/${channelId}/likes/${likeId}`;
}

export function getOrgPostsUrl(userId, orgId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/posts`;
}

export function getCompanyPostUrl(userId, companyId, postID) {
  return `/TaxPlanningServices/users/${userId}/companies/${companyId}/posts/${postID}`;
}

export function updatePostUrl(org, userId, postId){
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/posts/${postId}`;
}

export function getChannelDocumentUrl(org, userId, channelType, companyId) {
  return `/orgs/${org}/users/${userId}/channels/${channelType}/${companyId}/documents`;
}

export function getWorkpapersDownloadUrl(userId, companyId, year, org, questonierId, channelType) {
  return `/TaxPlanningServices/users/${userId}/channels/${channelType}/${companyId}/questions/pdf?year=${year}&org=${org}&questonierId=${questonierId}`;
}
export function getTeamUsers(userId, teamId) {
  return `/TaxPlanningServices/users/${userId}/teams/${teamId}`;
}
export function getTodoPostCreateUrl(org, userId, todoId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/posts/todo/${todoId}`;
}
export function getGMailCreateEntityUrl(userId, messageId, accountId) {
  return `/TaxPlanningServices/users/${userId}/v1/messages/${messageId}/createentity?account_id=${accountId}`;
}
export function getOutlookCreateEntityUrl(userId, accountId) {
  return `/TaxPlanningServices/users/${userId}/office365/createentity?account_id=${accountId}`;
}
export function getReadPostUrl(userId, companyId, postId) {
  return `/TaxPlanningServices/users/${userId}/posts/${postId}/read`;
}
export function getCompanyPostStarredUrl(userId, companyId, postId) {
  return `/TaxPlanningServices/users/${userId}/companies/${companyId}/posts/${postId}/starred`;
}
export function getUnReadPostUrl(userId, companyId, postId) {
  return `/TaxPlanningServices/users/${userId}/posts/${postId}/unread`;
}
export function getHandlePostUrl(org, userId, channelType, companyId, postId, handleId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/channels/${channelType}/${companyId}/posts/${postId}/handle?handle_on=${handleId}`;
}
export function getTeamPostStarredUrl(userId, teamId, postId) {
  return `/TaxPlanningServices/users/${userId}/teams/${teamId}/posts/${postId}/starred`;
}
export function getMoveToCompaniesUrl(org, userId, channelType, channelId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/channels/${channelType}/${channelId}/peers`;
}

@Injectable({
  providedIn: 'root'
})
export class CollaborationService extends TaxplanIQServices {
  teamData: any = {};
  constructor(httpClient: HttpClient, private switchBoard: SwitchBoard) {
    super(httpClient);
    
  }

  getPost(org, channelType, channelId, postId): Observable<any> {
    const url = getChannelPostUrl(org, Session.getUser().id, channelType, channelId, postId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removeAttachment(org, channelType, id, companyId): Observable<any> {
    const url = getDeleteDocumentUrl(org, Session.getUser().id, channelType, companyId);
    return this.delete(url + '/' + id, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createComment(org, channelType, data: any, companyId, postId, taskId): Observable<any> {
    let url;
    url = getOrgCommentUrl(org, Session.getUser().id, postId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getDocument(channelType, id, companyId): Observable<any> {
    let url;
    url = getDocumentDownloadUrl(Session.getUser().id, companyId, id);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }
 markTeamStarred(id, teamId): Observable<any> {
    const url = getTeamPostStarredUrl(Session.getUser().id, teamId, id);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteComment(commentId, postId): Observable<any> {
    const url = getCommentUrl(Session.getOrg(), Session.getUser().id, postId, commentId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  like(channelType, data, companyId, org): Observable<any> {
    const url = getCompanyLikeUrl(Session.getUser().id, companyId, channelType, org);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  unLike(channelType, id, companyId, orgId): Observable<any> {
    const url = getCompanyUnLikeUrl(orgId, Session.getUser().id, channelType, companyId, id);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateComment(org, channelType, data: any, type, companyId): Observable<any> {
    let url;
    if (type === 'post') {
      url = getOrgPostsUrl(Session.getUser().id, org) + '/' + data.id;
    } else {
      url = getOrgPostsUrl(Session.getUser().id, org) + '/' + data.postID + '/comments/' + data.id;
    }
    return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateAttachmentInPost(channelType, docData, companyId, postId): Observable<any> {
    let url = getCompanyPostUrl(Session.getUser().id, companyId, postId);
    if (channelType === 'leads' || channelType === 'orgs') {
      url = getOrgPostsUrl(Session.getUser().id, companyId);
      url = url + '/' + postId;
    }
    return this.patch(url, docData, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateCommentData(org: string, userId: any, commentId: any, comment: any) {
    const url = getOrgPostsUrl(Session.getUser().id, org) + '/' + comment.postID + '/comments/' + commentId;
    return this.update(url, comment, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updatePost(org: string, userId: any, postId: any, post: any) {
    const url = updatePostUrl(org, userId, postId);
    return this.update(url, post, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateAttachmentInPostAndComment(org, channelType, docData, docId, companyId, type, typeId): Observable<any> {
    let url = getChannelDocumentUrl(org, Session.getUser().id, channelType, companyId);
    url = url + '/' + docId + '?type=' + type + '&sourceId=' + typeId;
    return this.patch(url, docData, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  downloadPdf(companyId, org, year, questonierId?, channelType?): Observable<any> {
    const url = getWorkpapersDownloadUrl(Session.getUser().id, companyId, year, org, questonierId, channelType);
    return this.query(url, SOURCE_TYPE.JAVA, this.getHeaders()).pipe(catchError(this.handleError));
  }

  createPost(org, channelType, data: any, companyId): Observable<any> {
    let url = getChannelPostsUrl(org, Session.getUser().id, channelType, companyId);
    if (channelType === 'orgs') {
      url = getOrgPostsUrl(Session.getUser().id, org);
    } else {
      data.entityType = 'Tax Planning Todo';
      url = getTodoPostCreateUrl(org, Session.getUser().id, data.entityID);
    }
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deletePost(org, post): Observable<any> {
    // const url = getChannelPostsUrl(org, Session.getUser().id, channelType, companyId);
    let url = getOrgPostsUrl(Session.getUser().id, org);
    url = url + '/' + post.id + '?entityType=' + post.entityType + '&entityId=' + post.entityID;
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  markPostRead(companyId, id): Observable<any> {
    const url = getReadPostUrl(Session.getUser().id, companyId, id);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

    markPostUnread(companyId, id): Observable<any> {
    const url = getUnReadPostUrl(Session.getUser().id, companyId, id);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  markPostHandle(org, channelType, id, companyId, handleId, handlers): Observable<any> {
    const url = getHandlePostUrl(org, Session.getUser().id, channelType, companyId, id, handleId);
    return this.update(url, handlers, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

   getTeamUsers(temaId): Observable<any> {
    if (this.teamData[temaId]) {
      return observableOf(this.teamData[temaId]);
    }
    const url = getTeamUsers(Session.getUser().id, temaId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(map(res => {
      this.teamData[temaId] = res;
      return this.teamData[temaId];
    }), catchError(e => this.handleError(e)));
  }


  markCompanyStarred(id, companyId): Observable<any> {
    const url = getCompanyPostStarredUrl(Session.getUser().id, companyId, id);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

   getMoveToCompanies(channelType, companyId): Observable<any> {
    const url = getMoveToCompaniesUrl(Session.getOrg(), Session.getUser().id, channelType, companyId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

   createEntity(obj, mailObj): Observable<any> {
    let finalObj: any = {};
    let url = '';
    if (mailObj.mailType == 'gmail') {
      finalObj = obj;
      url = getGMailCreateEntityUrl(Session.getUser().id, obj.messageId, mailObj.currentAccount.account_id);
    } else if (mailObj.mailType === 'outlook') {
      finalObj.mapping = JSON.stringify(obj);
      url = getOutlookCreateEntityUrl(Session.getUser().id, mailObj.currentAccount.account_id);
    } else {
      finalObj = obj;
      url = `/CollaborationServices/users/${Session.getUser().id}/office365/createentity?account_id=${mailObj.currentAccount.account_id}`;
    }
    return this.create(url, finalObj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getHeaders(): any {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json;charset=UTF-8');
    headers = headers.append('Authorization', 'Bearer ' + Session.getToken());
    const options: any = {
      responseType: 'arraybuffer',
      headers
    };
    return options;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 403) {
      this.switchBoard.onLogOut.next({loggedOut: true});
    } else if (error.status === 401) {
      this.switchBoard.onLogOut.next({loggedOut: true});
    }
    return observableThrowError(error.error);
  }

}
